export const STORAGE_BACKUP_KEY = 'tzlvt_app_state_backup';
